<monster-custom-element *ngIf="(show$ | async)">
  <span class="d-none">{{ {id: flowId, isNlbCustomer, translations: translations} | json }}</span>
</monster-custom-element>
